// extracted by mini-css-extract-plugin
export var category = "index-module--category--evRLI";
export var date = "index-module--date--El3Ly";
export var date_category = "index-module--date_category--gl5xD";
export var recent_blogs = "index-module--recent_blogs--hxCDF";
export var single_blog = "index-module--single_blog--4SA52";